// Signal sans données personnelles : toutes les lectures restent filtrées par l'API.
export const PARRAINAGE_CHANGED = 'valnexo:parrainage-changed';
export const PARRAINAGE_REVISION_KEY = 'valnexo-parrainage-revision';

export function notifyParrainageMutation(config) {
    if (typeof window === 'undefined' || !['post', 'put', 'patch', 'delete'].includes(config?.method?.toLowerCase())) return;
    const path = config?.url || '';
    if (!/^\/(prospects|parrainage|admin\/prospects)(\/|\?|$)/.test(path)) return;
    window.dispatchEvent(new Event(PARRAINAGE_CHANGED));
    try {
        localStorage.setItem(PARRAINAGE_REVISION_KEY, `${Date.now()}-${Math.random()}`);
    } catch { /* Stockage indisponible : focus et polling prennent le relais. */ }
}